// Initial content for main destinations to populate content before callback
import home from './home.json'
import about from './about.json'
import projects from './projects.json'
import publications from './publications.json'
import contact from './contact.json'
import cookies from './cookies-privacy.json'

export const baseContent = {
    "/": home,
    "/about": about,
    "/projects": projects,
    "/publications": publications,
    "/contact": contact,
    "/cookies-privacy": cookies
}
